import { Controller } from "@hotwired/stimulus"
import Flatpickr from "stimulus-flatpickr"

// Connects to data-controller="submit-flatpickr"
export default class extends Flatpickr {
  // all flatpickr hooks are available as callbacks in your Stimulus controller
  change(selectedDates, dateStr, instance) {
    console.log('the callback returns the selected dates', selectedDates)
    console.log('but returns it also as a string', dateStr)
    console.log('and the flatpickr instance', instance)
    this.element.form.submit();
  }
}
